/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import ARControllerUI from "../components/ARControllerUI";
import "./LoadingBar.css";

function LoadingBar({ message }) {
  // const snippets = [
  //   "63% of online shoppers believe AR improves their shopping experience",
  //   "In 2020, as many as 32% of users have used AR for shopping.",
  //   "About one-seventh of the entire world’s population are AR users.",
  //   "Augmented Reality has over 1 billion users in 2020.",
  //   "1% of retailers have stated that they are already using augmented reality.",
  //   "61% of online shoppers choose websites that offer an AR experience.",
  //   "First-ever online shopping site was Pizza Hut in 1994",
  //   "Today, 100 million consumers are shopping with AR online and in-stores",
  //   "AR experiences allows customers to try before they buy",
  //   "A 25% reduction in product returns is observed for AR guided purchases",
  //   "Over 4.5 billion AR photos and/or videos are taken daily by consumers",
  //   "55% of consumers believe AR helps shoppers make better decisions",
  //   "56% of shoppers agree AR gives them more confidence about the product",
  // ];
  // const [snippetIndex, setSnippetIndex] = useState(
  //   Math.floor(Math.random() * snippets.length)
  // );

  // useEffect(() => {
  //   let timeout;
  //   if (snippetIndex < snippets.length - 1) {
  //     timeout = setTimeout(() => setSnippetIndex(snippetIndex + 1), 4000);
  //   }
  //   return () => {
  //     clearTimeout(timeout);
  //   };
  // }, [snippets, snippetIndex, setSnippetIndex]);

  return (
    <div className="loadingBar">
      {/* <ARControllerUI /> */}
      <img
        src="https://d179blwxwzk8ou.cloudfront.net/common/pfLoadSpinner.png"
        alt=""
        id="loader"
      />

      {/* <div className="snippets">{snippets[snippetIndex]}</div> */}
      {/* 3D Box ROTATING
      <div className="loader_xr" style={{ display: "block" }}>
        <div className="cube">
          <div className="sides">
            <div className="top" />
            <div className="right" />
            <div className="bottom" />
            <div className="left" />
            <div className="front" />
            <div className="back" />
          </div>
        </div>
        {message && <h2>{message}</h2>}
      </div> */}
    </div>
  );
}

export default LoadingBar;
